(() => {
  if (window.__BT_FreeShipBoundV2) return;
  window.__BT_FreeShipBoundV2 = true;
  let lastCartSig = null;
  const animateOnce = (root) => {
    if (!root) return;
    // Always animate after we insert refreshed HTML
    root.setAttribute('data-animated', '0');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.setAttribute('data-animated', '1');
      });
    });
  };
  const applyInitialWidth = () => {
    const root = document.getElementById('product-freeshipping-bar');
    const bar = root?.querySelector('.free-offer-bar');
    if (!bar) return;

    const target = parseFloat(bar.dataset.currentWidth || '0');
    if (Number.isNaN(target)) return;

    // Force the correct width back onto the bar (theme scripts may have reset it)
    bar.style.width = `${target}%`;
  };

  const refreshFromPageHTML = async () => {
    // Dedupe refreshes using cart signature (keep if you already have it)
    const cartRes = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (cartRes.ok) {
      const cart = await cartRes.json();
      const sig = `${cart.item_count}|${cart.total_price}`;
      if (sig === lastCartSig) return;
      lastCartSig = sig;
    }

    const current = document.getElementById('product-freeshipping-bar');
    if (!current) return;

    const sectionId = current.dataset.sectionId;
    if (!sectionId) return;

    // Use Shopify Section Rendering API (reliable across product + bundle pages)
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionId);

    const res = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!res.ok) return;

    const json = await res.json();
    const html = json[sectionId];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('product-freeshipping-bar');
    if (!fresh) return;

    current.replaceWith(fresh);
    // Keep your existing animation system
    animateOnce(fresh);
  };
  // Debounce + in-flight lock so multiple triggers become one refresh
  let timer = null;
  let inFlight = false;

  const scheduleRefresh = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(async () => {
      if (inFlight) return;
      inFlight = true;
      try {
        await refreshFromPageHTML();
      } finally {
        inFlight = false;
      }
    }, 150);
  };
  // Bundle add-to-cart triggers Eurus' cart event (may not use fetch /cart/add.js)
  document.addEventListener('eurus:cart:items-changed', () => {
    scheduleRefresh();
  });
  // Hook *actual cart requests* (most reliable)
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);

    try {
      const url = reflectUrl(args[0]);
      if (url && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url) && res.ok) {
        // Schedule refresh after cart mutation
        scheduleRefresh();
      }
    } catch (e) {
      // no-op
    }

    return res;
  };

  function reflectUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return '';
  }

  // Keep your page-load animation behavior intact
  // Ensure the bar renders correctly on initial page load (when cart already has items)
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('product-freeshipping-bar');
    if (!root) return;

    const bar = root.querySelector('.free-offer-bar');
    if (!bar) return;

    const target = parseFloat(bar.dataset.currentWidth || '0');
    if (Number.isNaN(target)) return;

    // Set width immediately so it doesn't appear empty on load
    bar.style.transition = 'none';
    bar.style.width = `${target}%`;

    // Restore transitions for later updates (add-to-cart)
    requestAnimationFrame(() => {
      bar.style.transition = 'width 700ms ease-in-out';
    });
  });
  window.addEventListener('load', () => {
  const root = document.getElementById('product-freeshipping-bar');
  if (!root) return;

  const bar = root.querySelector('.free-offer-bar');
  if (!bar) return; // no bar in "empty cart" state, which is correct

  animateOnce(root);
});
})();